import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const subCommitteeData = [
    //     { id: '01', title: 'Cultural', leader: 'Parthasarathi Bose' },
    //     { id: '02', title: 'Building & Maintenance', leader: 'Srikumar Bhattacharya' },
    //     { id: '03', title: 'Library', leader: 'Omkareswar Ghosh Dastidar' },
    //     { id: '04', title: 'Recreation', leader: 'Deepa Ray & Partha Pratim Daw' },
    //     { id: '05', title: 'Health & Care', leader: 'Biswarup Saha' },
    //     { id: '06', title: 'Seminar & Technical talk', leader: 'Alok Raychoudhury' },
    //     { id: '07', title: 'Souvenir', leader: 'Goutam Mondal' },
    //     { id: '08', title: 'Membership Directory',  leader: (
    //     <>
    //       Lokendra Nath Roychoudhury <br />
    //       & <br />
    //       Partha Pratim Ganguly
    //     </>
    //   )},
    //      { id: '09', title: 'IT', leader: 'Soma Pradhan' },
    //       { id: '10', title: 'Finance', leader: 'Ranjan Palit' }

    {
        id: '01', title: 'Cultural', chairman: 'Gautam Mandal', convenor: (
            <>
                Partha Sarathi Bose
                <br />
                & <br />
                Kunal Bhattacharya
            </>
        )
    },
    { id: '02', title: 'Building & Maintenance', chairman: 'Bibhas Adhikary', convenor: 'Dipankar Sarkar' },
    { id: '03', title: 'Library', chairman: 'Uttam Khan', convenor: 'Joy Chakraborty' },
    { id: '04', title: 'Recreation', chairman: 'Gautam De Sarkar', convenor: 'Debasis Chatterjee' },
    { id: '05', title: 'Health & Care', chairman: 'Madhusudan Das', convenor: 'Uttam Khan' },
    {
        id: '06', title: 'Seminar & Technical talk', chairman: 'Sukanta Roy', convenor: (
            <>
                Partha S Majumder
                <br />
                & <br />
                Arnab Banerjee
            </>
        )
    },
    { id: '07', title: 'Souvenir', chairman: 'Srikumar Bhattacharya', convenor: 'Debasis Chatterjee' },
    { id: '08', title: 'Membership Development and IT', chairman: 'Partha Ganguly', convenor: 'Soma Pradhan' },
    { id: '09', title: 'Finance', chairman: 'Ranjan Palit', convenor: '' }
];


const getCardColor = (index) => {
    const colors = ['#f09e06', '#3b82f6', '#8b5cf6', '#10b981', '#ef4444', '#6366f1', '#ec4899', '#14b8a6'];
    return colors[index % colors.length];
};

export default function SubCommittes() {
    return (
        <>
            <section className="new-member-slider py-5" style={{ background: 'linear-gradient(180deg, #f8fafc 0%, #fff 100%)' }}>
                <Container>
                    <Row className='justify-content-center mb-4'>
                        <Col lg={9} className="text-center">
                            <div className='heading'>
                                <h2>Sub Committees</h2>
                                <p>Our Subcommittees are led by our dedicated members who shoulder the responsibility of nurturing the Club's cultural, social, and knowledge-driven initiatives, while preserving its values and strengthening the bond that unites the B E College alumni community.</p>
                            </div>
                        </Col>
                    </Row>
                    <Row className='g-4'>
                        {subCommitteeData.map((committee, index) => {
                            const convenorValue = committee.convenor || committee.conventor;
                            return (
                                <Col lg={3} md={4} sm={6} xs={12} key={index}>
                                    <div style={{
                                        background: 'linear-gradient(180deg, #fff 0%, #f0f7ff 100%)',
                                        borderRadius: '16px',
                                        padding: '30px 20px',
                                        textAlign: 'center',
                                        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                        height: '100%',
                                        minHeight: '260px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                                    }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'translateY(-5px)';
                                            e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.12)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
                                        }}
                                    >
                                        {/* Circular Number Badge */}
                                        <div style={{
                                            width: '60px',
                                            height: '60px',
                                            borderRadius: '50%',
                                            backgroundColor: getCardColor(index),
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginBottom: '20px',
                                            boxShadow: `0 4px 15px ${getCardColor(index)}40`
                                        }}>
                                            <span style={{
                                                color: '#fff',
                                                fontSize: '20px',
                                                fontWeight: '700'
                                            }}>{committee.id}</span>
                                        </div>

                                        <h3 style={{
                                            fontSize: '16px',
                                            fontWeight: '700',
                                            color: '#1a1a2e',
                                            marginBottom: '12px',
                                            lineHeight: '1.3'
                                        }}>{committee.title}</h3>

                                        {/* Roles Footer Wrapper */}
                                        <div style={{
                                            marginTop: 'auto',
                                            width: '100%',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '10px',
                                            alignItems: 'center',
                                            paddingTop: '10px'
                                        }}>
                                            {committee.chairman ? (
                                                <span style={{
                                                    display: 'block',
                                                    backgroundColor: '#f09e06',
                                                    color: '#fff',
                                                    padding: '6px 14px',
                                                    borderRadius: '20px',
                                                    fontSize: '12px',
                                                    fontWeight: '600',
                                                    width: '100%',
                                                    maxWidth: '240px',
                                                    textAlign: 'center',
                                                    lineHeight: '1.4'
                                                }}>
                                                    Chairman : {committee.chairman}
                                                </span>
                                            ) : null}

                                            {convenorValue ? (
                                                <span style={{
                                                    display: 'block',
                                                    backgroundColor: '#f09e06',
                                                    color: '#fff',
                                                    padding: '6px 14px',
                                                    borderRadius: '20px',
                                                    fontSize: '12px',
                                                    fontWeight: '600',
                                                    width: '100%',
                                                    maxWidth: '240px',
                                                    textAlign: 'center',
                                                    lineHeight: '1.4'
                                                }}>
                                                    Convenor : {convenorValue}
                                                </span>
                                            ) : null}
                                        </div>
                                    </div>
                                </Col>
                            );
                        })}
                    </Row>
                </Container>
            </section>
        </>
    )
}